<template>
  <v-card>
    <v-data-table
      :headers="headers"
      :items="roles ? roles : []"
      :search="search"
      :loading="fetchAllLoading"
    >
      <template v-slot:top>
        <v-toolbar flat color="white">
          <v-btn icon small color="primary" class="ma-2" @click="$emit('refresh')">
            <v-icon>refresh</v-icon>
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn color="success" @click="$emit('createNew')">
            <v-icon left>add</v-icon>Create
          </v-btn>
        </v-toolbar>
        <v-card-title>
          <v-text-field
            v-model="search"
            append-icon="search"
            label="Search"
            single-line
            hide-details
          ></v-text-field>
        </v-card-title>
      </template>
      <template v-slot:item.name="props">
        <v-edit-dialog
          :return-value.sync="props.item.name"
          large
          persistent
          @save="$emit('editRole', props.item.uuid, nameToModify, props.item.description)"
          @open="nameToModify = props.item.name"
          @close="nameToModify = ''"
        >
          <div>{{ props.item.name }}</div>
          <template v-slot:input>
            <v-text-field
              v-model="nameToModify"
              :rules="[min3chars]"
              label="Edit"
              single-line
              counter
            ></v-text-field>
          </template>
        </v-edit-dialog>
      </template>
      <template v-slot:item.description="props">
        <v-edit-dialog
          :return-value.sync="props.item.description"
          large
          persistent
          @save="$emit('editRole', props.item.uuid, props.item.name, descriptionToModify)"
          @open="descriptionToModify = props.item.description"
          @close="descriptionToModify = ''"
        >
          <div>{{ props.item.description }}</div>
          <template v-slot:input>
            <v-text-field v-model="descriptionToModify" label="Edit" single-line counter></v-text-field>
          </template>
        </v-edit-dialog>
      </template>
      <template v-slot:item.actions="{ item }">
        <v-icon color="error" @click="$emit('deleteRole', item)">mdi-delete</v-icon>
      </template>
    </v-data-table>
  </v-card>
</template>

<script>
import { mapState } from "vuex";
export default {
  data() {
    return {
      search: "",
      nameToModify: "",
      descriptionToModify: "",
      headers: [
        {
          text: "Name",
          align: "start",
          filterable: true,
          value: "name",
          width: "20%"
        },
        {
          text: "Description",
          filterable: true,
          value: "description",
          width: "50%"
        },
        { text: "Actions", value: "actions", sortable: false, align: "right" }
      ]
    };
  },
  computed: {
    ...mapState({
      roles: state => state.roles.all,
      fetchAllLoading: state => state.roles.fetchAll.pending,
      fetchAllError: state => state.roles.fetchAll.error
    })
  },
  methods: {
    min3chars: v => v.length >= 3 || "Min. length: 3 characters."
  }
};
</script>